import type { ReactNode } from 'react';

import sectionStyles from './SectionStyles.module.scss';

type Props = {
	collapsibleMetadataBox: ReactNode;
	media: ReactNode;
};

export function ArticleModuleMedia({ collapsibleMetadataBox, media }: Props) {
	return (
		<section className={sectionStyles.section}>
			{media}

			{collapsibleMetadataBox}
		</section>
	);
}
